'use client';
import { useEffect, useRef } from 'react';
import drawAngles from '@/lib/visualisers/angles';

interface AngleOptions {
    strokeColor: string;
    arcColor: string;
    strokeWidth: number;
}

interface AngleVisualiserProps {
    angle: number;
    options: AngleOptions;
}

export default function AngleVisualiser({ angle, options }: AngleVisualiserProps) {
    const canvasRef = useRef<HTMLCanvasElement>(null);

    useEffect(() => {
        const c = canvasRef.current;
        if (!c) return;
        drawAngles(c, { angle, ...options, size: 400 });
    }, [angle, options]);

    return (
        <div className="flex w-full max-w-[400px] flex-col items-center rounded-lg border-[0.5px] border-line bg-white p-5">
            <canvas
                ref={canvasRef}
                aria-label={`Visualisation of a ${angle} degree angle`}
                className="h-auto w-full"
            />
            <div className="mt-3 text-sm text-muted">
                Visualising a{' '}
                <strong className="font-medium text-ink">{angle}°</strong> angle
            </div>
        </div>
    );
}
